import { EDealType, Filters } from 'shared/types/filters';

export function isSale(filters: Filters): boolean {
  return filters.dealType === EDealType.Sale;
}
